import { COLORS, MAP_STATUS_COLORS } from "styles/colors";
import styled, { css } from "styled-components";
import { FLEX } from "styles/flex";
import { calcRem } from "styles/theme";
import {
  changeColorMapMarkerStatus,
  MapStatusType,
  MarkerWrapper,
} from "./MarkerCommonStyled";
import { clusterAlert } from "../../GoogleMapContainer";

export interface Props extends clusterAlert {
  totalRecorder: number;
  animatedRecorders: string[];
}
const getClusterScale = (status: MapStatusType) => {
  let scaleSize = 1;

  if (status.warningCount > 0) {
    scaleSize = 1.4;
  }

  if (status.alertCount > 0) {
    scaleSize = 1.6;
  }
  if (status.criticalCount > 0) {
    scaleSize = 1.8;
  }
  return scaleSize;
};
const changeTotalCircle = (recs: number): number => {
  if (recs < 10) {
    return 50;
  }
  if (recs < 30) {
    return 60;
  }

  if (recs < 100) {
    return 80;
  }
  if (recs < 200) {
    return 100;
  }
  if (recs < 500 && recs >= 200) {
    return recs * 0.6;
  }
  if (recs < 999 && recs >= 500) {
    return recs * 0.7;
  }
  return 100;
};

export default function ClusterMarker(props: Props): JSX.Element {
  return (
    <Wrapper
      status={{
        alertCount: props.alertStatusCount.alertCount,
        criticalCount: props.alertStatusCount.criticalCount,
        warningCount: props.alertStatusCount.warningCount,
      }}
      totalRecorder={props.totalRecorder}
    >
      <div className="clusterer-circle-bg"></div>
      <div className="map-marker-inner">
        {/* {props.totalRecorder >= 10 && (
          <> */}
        <p className="map-marker-count ">
          {props.totalRecorder > 999 ? "999+" : props.totalRecorder}
        </p>
        <p>SYS</p>
        {/* </>
        )} */}
      </div>
    </Wrapper>
  );
}

const Wrapper = styled(MarkerWrapper)<{ totalRecorder: number }>`
  width: ${({ totalRecorder }) => `${changeTotalCircle(totalRecorder)}px`};
  height: ${({ totalRecorder }) => `${changeTotalCircle(totalRecorder)}px`};
  position: relative;
  user-select: none;
  -webkit-user-drag: none;

  .map-marker-inner {
    background-color: ${(props) =>
      `${changeColorMapMarkerStatus(props.status)}`}E6;
    ${FLEX.FlexCenterCenter};
    flex-direction: column;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    color: ${COLORS.WHITE};
    font-weight: 500;
    z-index: 2;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    .map-marker-count {
      font-size: ${calcRem(28)};
    }
  }

  .clusterer-circle-bg {
    background-color: ${(props) =>
      `${changeColorMapMarkerStatus(props.status)}`};
    width: ${({ totalRecorder }) =>
      `${changeTotalCircle(totalRecorder) + 8}px`};
    height: ${({ totalRecorder }) =>
      `${changeTotalCircle(totalRecorder) + 8}px`};
    border-radius: 50%;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    opacity: 0.7;
    pointer-events: none;
    ${({ status, totalRecorder }) =>
      changeColorMapMarkerStatus(status) !== MAP_STATUS_COLORS.HEALTHY &&
      css`
        --cluster-scale: ${getClusterScale(status)};
        animation: clusterPulse 1.8s infinite;
        animation-delay: ${totalRecorder % 2 === 0 ? 0.3 : 0}s;
      `}
  }

  // hover 했을 때
  .clusterer-circle-bg.circle-animation {
    animation: clusterAnimatePulse 1.8s infinite;
  }
`;
